// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2t1oP","col":"styles_col__3sjom","fulfillmentStatus":"styles_fulfillmentStatus__a2Rd2","emailCol":"styles_emailCol__1iLXb"};